import React, { useState } from "react";
import axios from "axios";
import './GPT.css';

const CodeGenerationComponent = () => {
  const [userInput, setUserInput] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchData = async () => {
    if (!userInput) {
      setError("Input cannot be empty.");
      return;
    }

    setLoading(true);
    setError("");

    const options = {
      method: "POST",
      url: "https://api.edenai.run/v2/text/code_generation",
      headers: {
        authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMGI2ZTBjMTEtNGI3NC00NTE5LWJhZjQtN2E0OTgwZGEwZDhjIiwidHlwZSI6ImFwaV90b2tlbiJ9.RSb5g43oolZC0EH9egfjhoUcLFg7cNf8JpF4IetyoCY",
      },
      data: {
        providers: "openai",
        prompt: userInput,
        instruction: userInput,
        temperature: 0.1,
        max_tokens: 500,
      },
    };

    try {
      const response = await axios.request(options);
      const generatedText = response.data.openai.generated_text;

      // Add the new prompt and response to the chat history
      setChatHistory(prevHistory => [
        ...prevHistory,
        { prompt: userInput, response: generatedText }
      ]);

      // Clear the input field after sending
      setUserInput("");
    } catch (error) {
      console.error("API Error:", error.response ? error.response.data : error.message);
      setError("An error occurred while fetching the data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-between h-screen w-full p-4">
      <div className="flex-grow w-full flex flex-col items-center justify-center overflow-hidden">
        {error && (
          <div className="mt-4 text-red-500">
            {error}
          </div>
        )}
        <div className="mt-4  relative p-4 rounded w-full h-[90%] max-h-full overflow-y-auto custom-scrollbar">
          {loading && (
            <div className="text-center">
              <div className="loader"></div> {/* Placeholder for the loader */}
              <p>Loading...</p>
            </div>
          )}
          {!loading && chatHistory.length === 0 && (
            <div className="container absolute top-[50%] left-[50%]  translate-x-[-50%] translate-y-[-50%]">
              <div className="content">
                <div className="content__container">
                  <p className="content__container__text text-[#000000]">
                    Hello
                  </p>
                  <ul className="content__container__list">
                    <li className="content__container__list__item text-[#FF6500]">world !</li>
                    <li className="content__container__list__item text-[#FF6500]">coder !</li>
                    <li className="content__container__list__item text-[#FF6500]">users !</li>
                    <li className="content__container__list__item text-[#FF6500]">universe !</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          {chatHistory.map((chat, index) => (
            <div key={index} className="mb-4">
              <div className="font-bold text-[#000000]">You:</div>
              <pre className="whitespace-pre-wrap text-[#000000]">{chat.prompt}</pre>
              <div className="font-bold text-[#000000] mt-2">AI:</div>
              <pre className="whitespace-pre-wrap">{chat.response}</pre>
            </div>
          ))}
        </div>
      </div>
      <div className="h-auto w-full flex flex-row items-center gap-3 justify-center ">
        <input
          type="text"
          className="w-[90%] bg-[#ffffff43] sm:text-sm md:text-[16px] p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#FF6500]"
          placeholder="Enter your prompt and instruction here..."
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
        />
        <button
          onClick={fetchData}
          className="bg-[#FF6500] text-white px-4 py-2 rounded hover:bg-[#FF6500]/80 transition"
          disabled={loading}
        >
          {loading ? "Loading..." : "Send"}
        </button>
      </div>
    </div>
  );
};

export default CodeGenerationComponent;
